var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadedPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 100,
    viewBox: "0 0 75 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-pdf",
    "data-name": "Icon awesome-file-pdf",
    d: "M35.527,50.02c-.977-3.125-.957-9.16-.391-9.16C36.777,40.859,36.621,48.066,35.527,50.02ZM35.2,59.238a90.123,90.123,0,0,1-5.547,12.246c3.574-1.367,7.617-3.359,12.285-4.277A25.3,25.3,0,0,1,35.2,59.238ZM16.816,83.613c0,.156,2.578-1.055,6.816-7.852C22.324,76.992,17.949,80.547,16.816,83.613ZM48.438,31.25H75V95.313A4.676,4.676,0,0,1,70.313,100H4.688A4.676,4.676,0,0,1,0,95.313V4.688A4.676,4.676,0,0,1,4.688,0H43.75V26.562A4.7,4.7,0,0,0,48.438,31.25ZM46.875,64.8A19.6,19.6,0,0,1,38.535,54.3c.879-3.613,2.266-9.1,1.211-12.539-.918-5.742-8.281-5.176-9.336-1.328-.977,3.574-.078,8.613,1.582,15.039a183.4,183.4,0,0,1-7.969,16.758c-.02,0-.02.02-.039.02C18.691,74.961,9.609,80.937,13.34,85.527a6.069,6.069,0,0,0,4.2,1.953c3.5,0,6.973-3.516,11.934-12.07,5.039-1.66,10.566-3.73,15.43-4.531,4.238,2.3,9.2,3.809,12.5,3.809,5.7,0,6.094-6.25,3.848-8.477-2.715-2.656-10.605-1.895-14.375-1.406Zm26.758-44.3L54.492,1.367A4.684,4.684,0,0,0,51.172,0H50V25H75V23.809A4.673,4.673,0,0,0,73.633,20.508ZM59.16,70.371c.8-.527-.488-2.324-8.359-1.758C58.047,71.7,59.16,70.371,59.16,70.371Z",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadedPdf);
export default __webpack_public_path__ + "static/media/iconUploadedPdf.dd6e7933e96d7abfc53f6ff98433040b.svg";
export { ForwardRef as ReactComponent };